import React from 'react';
import { createRoot } from 'react-dom/client';

import 'whatwg-fetch';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

import './styles.scss';
import './helpers/globalAuth';

import Routes from './routes';

TimeAgo.addDefaultLocale(en);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
);
